export const MerchantListItemActionFooterStyles = {
  buttonContainer: 'bg-gray40 flex justify-center p-5'
}
